import { Button } from '@strata/react-buttons';
import { NumberInputFormik, TextInputFormik } from '@strata/react-inputs';
import { DetailLabel } from '@strata/react-label-value-pairs';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import PropTypes from 'prop-types';

const DoseModifierOptions = ['Weight', 'BSA'];

export const MedDirection = ({ arrayHelpers, index }) => (
    <>
        <div style={{ display: 'inline-block' }}>
            <DetailLabel label="Prescribing Direction" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className="margin__right--small">
                <TextInputFormik id={`directions.${index}.option`} label="Option" required />
            </div>
            <div className="margin__right--small">
                <NumberInputFormik
                    id={`directions.${index}.value`}
                    label="Value"
                    required
                    step="0.01"
                    maxDecimalPlaces={2}
                />
            </div>
            <div className="margin__right--small">
                <SuggestSingleSelectFormik
                    id={`directions.${index}.dose_modifier`}
                    label="Dose Mod"
                    values={DoseModifierOptions}
                />
            </div>
            <div className="margin__right--small">
                <NumberInputFormik
                    id={`directions.${index}.strength`}
                    label="Strength"
                    required
                    step="0.01"
                    maxDecimalPlaces={2}
                />
            </div>
            <div className="margin__right--small">
                <TextInputFormik id={`directions.${index}.strength_uom`} label="Str UOM" required />
            </div>
            <div className="sds_form-button__center-with-inputs">
                <Button label="Delete" onClick={() => arrayHelpers.remove(index)} />
            </div>
        </div>
    </>
);

MedDirection.propTypes = {
    index: PropTypes.number.isRequired,
    arrayHelpers: PropTypes.shape({
        remove: PropTypes.func,
    }).isRequired,
};
